export default __webpack_public_path__ + "static/media/RPReplay_Final1586719710.a75f045c.mov";